import { render, staticRenderFns } from "./forget-password-phone.vue?vue&type=template&id=e88307b4&"
import script from "./forget-password-phone.vue?vue&type=script&lang=js&"
export * from "./forget-password-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports